import React from 'react'
import { FormComponent } from './form/DynamicForm'
import { Form, Validators } from './form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../Http';

class GuiaInfo extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'guia/info', saveUrl: '', backUrl: '' },
      new Form([
        Form.Field('text', 'g_folio', 'Guia', '', [Validators.required], 4, [], [], [], false, true),
        Form.Field('text', `cliente`, 'Cliente', '', [Validators.required], 8, [], [], [], false, true),
        Form.Field('date', 'g_fecha', 'Fecha Guia', '', [Validators.required], 4, [], [], [], false, true),
        Form.Field('date', 'g_fecha_entrega', 'Fecha Entrega', '', [Validators.required], 4, [], [], [], false, true),
        Form.Field('text', 'g_estado_descripcion', 'Estado', '', [Validators.required], 4, [], [], [], false, true),
      ], [], 'Informacion Guia'), this.formData
    )
    if (this.props.idGuia) {
      this.LoadPreds(this.props.idGuia);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.idGuia !== prevProps.idGuia) {
      this.LoadPreds(this.props.idGuia);
    }
  }

  LoadPreds = async (predId = null) => {
    let id = predId;
    let Res = await Http.get(`guia/info/${id}`);
    if (!Res.error) {
      let guia = {
        ...Res.data,
        cliente: Res.data.cliente.cliente_rsocial
      }
      this.setState({ FormData: Form.Patch(this.state.FormData, guia) })
    }
    return Res.data;
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(GuiaInfo)
